// extracted by mini-css-extract-plugin
module.exports = {"loading-screen":"LoadingSpinner_loading-screen__2q_ha","ldsRing":"LoadingSpinner_ldsRing__3A0be"};